import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
const LinkTargetContext = createContext({ retainTarget: false });
export const useLinkTargetContext = () => useContext(LinkTargetContext);
export const LinkTargetProvider = ({ retainTarget, children, }) => {
    return _jsx(LinkTargetContext.Provider, { value: { retainTarget }, children: children });
};
